// extracted by css-extract-rspack-plugin
export default {"chip":"tpDijG4GqPUsmHxL","icon":"C1UePnSyDiwJisma"};